import { render, staticRenderFns } from "./InsertRoutes.vue?vue&type=template&id=0b94d56f&"
import script from "./InsertRoutes.vue?vue&type=script&lang=js&"
export * from "./InsertRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports